import { Component, OnInit } from '@angular/core';
import {
    ControlContainer,
    FormBuilder,
    FormGroup,
    FormGroupDirective,
    Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'ols-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
})
export class InputComponent implements OnInit {
    public form: FormGroup;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.form = this.fb.group({
            giftCardID: ['', Validators.required],
        });
    }

    public goToPurchaseGiftCardPage() {
        this.router.navigate(['../'], { relativeTo: this.route });
    }

    public submitForm() {
        if (this.form.valid) {
            const giftCardID: string = this.form.controls.giftCardID.value;

            this.router.navigate([`./${giftCardID}`], {
                relativeTo: this.route,
            });
        } else {
            this.form.markAllAsTouched();
        }
    }
}
